// Webpack Imports
import * as bootstrap from 'bootstrap';


( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );


// Megamenu
	$('ul#menu-main-menu a[href="#dropdown"]').click(function(event){
    event.preventDefault();
		var subMenu = $(this).parent().find('>.sub-menu');
		if ($(this).hasClass('active')){
			$(this).toggleClass('active');
			subMenu.toggleClass('open');
		}else{
			$('ul#menu-main-menu a[href="#dropdown"]').removeClass('active');
			$('.sub-menu.open').removeClass('open');
			$(this).toggleClass('active');
			subMenu.toggleClass('open');
		}
	});

	$(document).click(function(event) {
	  var $target = $(event.target);
	  if(!$target.closest('#bottomnav').length && $('.sub-menu').hasClass('open')) {
			$('ul#menu-main-menu a[href="#dropdown"]').removeClass('active');
	    $('.sub-menu.open').removeClass('open');
	  }
	});



// Mobile Nav


	function openMobileNav(){
		$('#mobile-navbar').addClass('open');
		$('#mobile-navbar').show();
		$('body').addClass('overflow-hidden');
		$('#mobile-menu-btn i.bi-list').hide();
		$('#mobile-menu-btn i.bi-x-circle').show();
		$('#header-search-form').removeClass('active');
	}
	function closeMobileNav(){
		$('#mobile-navbar').removeClass('open');
		$('#mobile-navbar').hide();
		$('body').removeClass('overflow-hidden');
		$('#mobile-menu-btn i.bi-list').show();
		$('#mobile-menu-btn i.bi-x-circle').hide();
		$('#mobile-navbar ul.sub-menu').hide();
		$('#mobile-navbar ul.sub-menu').removeClass('open');
	}

	$('#mobile-menu-btn').click(function(){
		if ($('#mobile-navbar').hasClass('open')){
			closeMobileNav();
		} else {
			openMobileNav();
		}
	});
	$(window).resize(function() {
		if ($(window).width() > 991) {
			closeMobileNav();
		}
	});

	$('.mobile-next a').click(function(){
		$(this).parent().children('ul.sub-menu').show();
		$(this).parent().children('ul.sub-menu').addClass('open');
	});
	$('.mobile-back a').click(function(){
		$(this).parent().parent().toggle();
		$(this).parent().parent().removeClass('open');
	});



	$(document).click(function(event) {
	  var $target = $(event.target);
	  if(!$target.closest('#topnav').length && $('#header-search-form').hasClass('active')) {
			$('#header-search-form').removeClass('active');
	  }
	});
	$('#mobile-search-btn').click(function(){
		closeMobileNav();
		$('#header-search-form').toggleClass('active');
	});



// Home Slider



	var currentSlide = 1;
  var slideCount = $('.home-slider .slide').length;

  var interval;
  var autoSlide = function(){
    interval = setInterval(function(){
      if (currentSlide < slideCount) {
        currentSlide++;
        $('.slide').fadeOut();
        $('.slide[data-slide="' + currentSlide + '"]').fadeIn();
      } else {
        currentSlide = 1;
        $('.slide').fadeOut();
        $('.slide[data-slide="1"]').fadeIn();
      }
    }, 20000 );
  }

	autoSlide();

  $('#next').click(function(){
    if (currentSlide < slideCount) {
      currentSlide++;
      $('.slide').fadeOut();
      $('.slide[data-slide="' + currentSlide + '"]').fadeIn();
    } else {
      currentSlide = 1;
      $('.slide').fadeOut();
      $('.slide[data-slide="1"]').fadeIn();
    }
    clearInterval(interval);
    autoSlide();
  });
	$('#prev').click(function(){
    if (currentSlide > 1) {
      currentSlide--;
      $('.slide').fadeOut();
      $('.slide[data-slide="' + currentSlide + '"]').fadeIn();
    } else {
      currentSlide = slideCount;
      $('.slide').fadeOut();
      $('.slide[data-slide="' + slideCount + '"]').fadeIn();
    }
    clearInterval(interval);
    autoSlide();
  });


// Scrolling Row on mobile

// $(window).on('scroll', function() {
//   $(".scrolling-row").each(function() {
//     if (isScrolledIntoView($(this))) {
//       $(this).addClass("animate-on");
//     } else {
// 			$(this).removeClass("animate-on");
// 		}
//   });
// });
// function isScrolledIntoView(elem) {
//   var docViewTop = $(window).scrollTop();
//   var docViewBottom = docViewTop + $(window).height();
//
//   var elemTop = $(elem).offset().top;
//   var elemBottom = elemTop + $(elem).height();
//
//   return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
// }



// Sidebar open / close
	$('#open-sidebar').click(function(){
		$('#sidebar-woocommerce').addClass('active');
		$('#products').addClass('sidebar-open');
		$('body').addClass('sidebar-open');
	});
	$('#close-sidebar').click(function(){
		$('#sidebar-woocommerce').removeClass('active');
		$('#products').removeClass('sidebar-open');
		$('body').removeClass('sidebar-open');
	});
	$(document).click(function(event) {
	  var $target = $(event.target);
	  if(!$target.closest('#sidebar-woocommerce').length && !$target.closest('#open-sidebar').length && $('#sidebar-woocommerce').hasClass('active')) {
			$('#sidebar-woocommerce').removeClass('active');
			$('#products').removeClass('sidebar-open');
			$('body').removeClass('sidebar-open');
	  }
	});

	// hack fix for WooCommerce Product Bundles & WooCommerce Variation Gallery plugins conflict
	$(document).ready(function(){
		$(".product-details div.bundle_form > div.bundled_product > .bundled_product_images > figure.bundled_product_image > a > img").removeClass("wp-post-image");
	});


} )();
